import React, {useState, useEffect} from 'react';
import {
  Modal,
  Box,
  Typography,
  TextField,
  Checkbox,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import closeIcon from '../../../../../../../assets/icons/close-icon.svg';
import './sessionModal.scss';
import Button from '../../../../../../../components/form/button/button';
import {
  attendanceByDate,
  saveSessionForAttendance,
  getNewAttendance,
  editAttendance,
} from '../../../../../../../redux/risk-assessment-core/riskAssessmentCoreSlice';
import {useDispatch, useSelector} from 'react-redux';
import {getAttendanceByDateData} from '../../../../../../../redux/selectors/riskAssessmentCore';
import {getLoginStateSelector} from '../../../../../../../redux/selectors/loginSelector';
import {toast} from 'react-toastify';
import {getRiskAssessmentStateSelector} from '../../../../../../../redux/selectors/riskAssessment';
import {useLocation} from 'react-router-dom';
import {getUserListSelector} from '../../../../../../../redux/selectors/userList';
import {hoursToHoursMinutes} from '../../../../utils/helpers';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: '8px',
};

const SessionModal = ({
  open,
  onClose,
  isEditModal = false,
  selectedAttendance,
  riskAssessmentUsers,
}) => {
  const dispatch = useDispatch();

  const location = useLocation();

  const raData = location?.state?.selectedRiskAssessment;

  const riskAssessmentId = raData?.id;

  const [attendance, setAttendance] = useState([]);
  const [selectedDate, setSelectedDate] = useState();
  const [hour, setHour] = useState(0);
  const [minute, setMinute] = useState(0);
  const [newAttendee, setNewAttendee] = useState('');
  const [addManually, setAddManually] = useState(false);

  const attendanceByDateData = useSelector(getAttendanceByDateData());
  const loginState = useSelector(getLoginStateSelector());
  const loggedInId = loginState?.loggedInUser?.id;

  // // logic for risk assessment users
  // const riskAssessments = useSelector(getRiskAssessmentStateSelector());

  // const specificRiskAssessment = riskAssessments.find(
  //   ra => ra.id === riskAssessmentId,
  // );

  // const riskAssessmentUsers = specificRiskAssessment?.users || [];

  const userListState = useSelector(getUserListSelector());

  useEffect(() => {
    if (!isEditModal && Array.isArray(userListState?.userList)) {
      const formattedData = riskAssessmentUsers?.map(item => {
        const itemData = userListState?.userList?.find(
          data => data.id === item,
        );
        return itemData;
      });

      setAttendance(formattedData);
    }
  }, [userListState]);

  useEffect(() => {
    if (selectedAttendance) {
      const {hours, minutes} = hoursToHoursMinutes(selectedAttendance?.time);
      const date = new Date(selectedAttendance.date);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
      const day = String(date.getDate()).padStart(2, '0');

      const formattedDate = `${year}-${month}-${day}`;
      setHour(hours);
      setMinute(minutes);
      setSelectedDate(formattedDate);
      setAttendance([
        {
          fullname: selectedAttendance?.name,
          id: selectedAttendance?.employee_id,
        }
      ]);
    }
  }, [selectedAttendance]);

  // useEffect(() => {
  //   if (attendanceByDateData) {
  //     setAttendance(attendanceByDateData?.attendance ?? []);
  //   }
  // }, [attendanceByDateData]);

  const fetchAttendance = date => {
    // if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    //   console.error("Invalid date format. Expected 'YYYY-MM-DD'.");
    //   return;
    // }
    // const formattedDate = date.replace(/^(\d{4})-(\d{2})-(\d{2})$/, '$2-$3-$1');
    // dispatch(attendanceByDate(formattedDate));

    setSelectedDate(date); // Store the selected date in state
  };

  const toggleCheckbox = id => {
    setAttendance(prev =>
      prev.map(item =>
        item.id === id ? {...item, checked: !item.checked} : item,
      ),
    );
  };

  //convertion to minutes
  const timeToMinutes = time => {
    const [hour, minute] = time.split(':').map(Number);
    return hour * 60 + minute;
  };

  const handleAddAttendee = () => {
    if (newAttendee.trim() !== '') {
      const newId = attendance.length + 1;
      setAttendance(prev => [
        ...prev,
        {id: newId, name: newAttendee, checked: true},
      ]);

      setNewAttendee('');
      setAddManually(false);
    }
  };

  const handleValidate = (checkedNames = []) => {
    if (
      (!isEditModal && checkedNames?.length === 0) ||
      (hour <= 0 && minute <= 0) ||
      !selectedDate
    ) {
      toast.error(
        'Oops! Looks like some fields are empty. Please fill them in before saving.',
        {
          autoClose: 2000,
          className: 'toast-error',
        },
      );

      return true;
    }

    return false;
  };


const handleSaveSession = () => {
  const checkedNames = attendance?.filter(attendee => attendee?.checked);

  if (handleValidate(checkedNames)) {
    return;

    }

    // ?.map(filteredAttendee => filteredAttendee?.name);
    const payload = {
      date: selectedDate,
      duration: timeToMinutes(`${hour}:${minute}`),
      name: checkedNames,
      employee_id: loggedInId,
      logged_by_id: loggedInId,
      riskAssessmentId,
    };

    dispatch(
      saveSessionForAttendance({
        payload,
        callback: result => {
          // toast.success('Session saved successfully.', {
          //   autoClose: 2000,
          //   className: 'toast-success',
          // });
          onClose(true);
        },
      }),
    );
  }

  const handleEdit = () => {
    if (handleValidate()) {
      return;
    }
    const data = {
      duration: timeToMinutes(`${hour}:${minute}`),
      date: selectedDate,
      id: selectedAttendance?.key,
    };
    dispatch(
      editAttendance({
        data,
        callback: () => {
          // toast.success('Session updated successfully.', {
          //   autoClose: 2000,
          //   className: 'toast-success',
          // });

          onClose(true);
        },
      }),
    );
  };

  const handleHourChange = value => {
    const num = Number(value);

    if (num < 0 || num > 24) {
      return;
    }

    if (num === 24) {
      setMinute(0);
    }
    setHour(value);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
          <Typography variant="h5" style={{fontWeight: 'bold'}}>
            Session
          </Typography>
          <img
            onClick={onClose}
            src={closeIcon}
            alt="close"
            style={{cursor: 'pointer'}}
          />
        </Box>

        <Box sx={{mt: 2}}>
          <Typography style={{fontWeight: 'bold'}}>Date</Typography>
          <TextField
            type="date"
            fullWidth
            value={selectedDate}
            InputLabelProps={{shrink: true}}
            onChange={e => fetchAttendance(e.target.value)}
          />
        </Box>

        <Box sx={{mt: 2}}>
          <Typography style={{fontWeight: 'bold', marginBottom: '10px'}}>
            Time
          </Typography>
          <Box sx={{display: 'flex', gap: 1}}>
            <TextField
              label="Hour"
              type="number"
              fullWidth
              value={hour}
              onChange={e => handleHourChange(e.target.value)}
            />
            <TextField
              label="Min"
              type="number"
              disabled={Number(hour) === 24}
              fullWidth
              value={minute}
              onChange={e => {
                const num = Number(e.target.value);
                if (num < 0 || num > 59) {
                  return;
                }
                setMinute(e.target.value);
              }}
              
            />
          </Box>
        </Box>

{  !isEditModal &&      <Box sx={{mt: 2}}>
          <Typography style={{fontWeight: 'bold'}}>Attendance</Typography>
          <List className="attendance-list">
            {attendance?.sort((a,b)=> (a?.first_name ?? "").localeCompare(b?.first_name ?? "")).map(attendee => (
              <ListItem
                className="attendance-list"
                key={attendee.id}
                sx={{px: 0}}>
                <ListItemIcon className="attendance-list-item-icon">
                  <Checkbox
                    disabled={isEditModal}
                    checked={isEditModal ? true : attendee.checked}
                    onChange={() => toggleCheckbox(attendee.id)}
                  />
                </ListItemIcon>
                <ListItemText primary={(!attendee?.first_name && !attendee?.last_name)? attendee?.email:`${attendee?.first_name ?? "N/A"} ${attendee?.last_name ?? ""}`} />
              </ListItem>
            ))}
          </List>
        </Box>
}
        <div className="save-session">
          <Button
            variant="secondary-button"
            clickHandler={isEditModal ? handleEdit : handleSaveSession}>
            Save Session
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default SessionModal;
